import { useTranslation } from '@mukil/i18n';
import { Button, GlassCard, StatusPill } from '@jumpstone/ui-react';
import { PAY_RUN_STATUS_KEY, PAY_RUN_STATUS_PILL } from '../../lib/label_keys';
import { format_date, format_month_year } from '../../lib/format';
import { navigate } from '../../lib/router';
import type { PayRun } from '../../data/types';

/** Shortcut back into the pay run that is currently open. */
export function CurrentRunCard({ run }: { run: PayRun }): React.JSX.Element {
  const { t, locale } = useTranslation('wp');

  return (
    <GlassCard variant="accent" className="rounded-2xl p-5">
      <h2 className="text-[14.5px] font-bold mb-2.5">
        {t('dashboard.current_run', {
          period: format_month_year(run.period, locale),
        })}
      </h2>
      <div className="flex items-center gap-2.5 mb-2.5">
        <StatusPill
          status={PAY_RUN_STATUS_PILL[run.status]}
          label={t(PAY_RUN_STATUS_KEY[run.status])}
        />
        <span className="text-[12.5px] text-[color:var(--ink-muted)]">
          {t('pay_run.filing_due', {
            date: format_date(run.filing_due_on, locale),
          })}
        </span>
      </div>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          navigate({ module: 'payroll', tab: 'run' });
        }}
      >
        {t('dashboard.continue_run')}
      </Button>
    </GlassCard>
  );
}
